import React, { Component } from 'react';
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
import { Layout, Icon, Typography, Row, Col, Button, Form, Input, Card, Spin } from 'antd';
import Banner from '../../components/contact/banner'
import ContactForm from '../../components/contact/concactForm'
import { Helmet } from "react-helmet";
const FormItem = Form.Item;
const { Title } = Typography;
const { Content } = Layout;
const { TextArea } = Input;

class Contact extends Component {

  componentDidMount() {
    window.fbq('track', 'ViewContent');
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFields((err) => {
      if (!err) {
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div className="contactuspage">
        <Helmet>
          <title>Contact Us</title>
          <meta name="description" content=" Have anyting to discuss with us? We are always ready to help!" />
        </Helmet>
        <TopNav history={this.props.history} />
        <Banner />
        <div className="container contact-us-page">
          <div className="row">
            <div className="col-md-6 col-sm-12 col-xs-12 wow fadeInLeft">
              <div className="contact-us-form">
                <h2>Send a Message</h2>
                <ContactForm />
                {/* <form action="inc/sendemail.php" className="form-validation" autocomplete="off">
                  <div className="row">
                    <div className="col-xs-12">
                      <div className="single-input">
                        <input type="text" placeholder="You Name*" name="name" />
                      </div>
                    </div>
                    <div className="col-xs-12">
                      <div className="single-input">
                        <input type="email" placeholder="Enter Email here*" name="email" />
                      </div>
                    </div>
                    <div className="col-sm-6 col-xs-12">
                      <div className="single-input">
                        <input type="text" placeholder="Phone Number" name="phone" />
                      </div>
                    </div>
                    <div className="col-xs-12">
                      <div className="single-input">
                        <textarea placeholder="Your Message" name="message"></textarea>
                      </div>
                    </div>
                  </div>
                  <input type="submit" value="Send Message" className="tran3s p-bg-color" />
                </form> */}
              </div>
            </div>

            <div className="col-md-6 col-sm-12 col-xs-12 wow fadeInRight">
              <div className="contactUs-address">
                <h2>Contact Information</h2>
                <p>There are many variations of passages of Lorem Ipsum available but the majority have suffered alteration in
          some form,</p>
                <div className="single-address clearfix">
                  <div className="icon float-left"><i className="flaticon-placeholder"></i></div>
                  <div className="text float-left">
                    <h6>Address</h6>
                    <span>San Francisco, CA 560 Bush St &amp; 20th Ave, Apt <br />5 San Francisco, 230909</span>
                  </div>
                </div>
                <div className="single-address clearfix">
                  <div className="icon float-left"><i className="flaticon-envelope"></i></div>
                  <div className="text float-left">
                    <h6>Email</h6>
                    <span>denis@email.com</span>
                  </div>
                </div>
                <div className="single-address clearfix">
                  <div className="icon float-left"><i className="flaticon-phone-call"></i></div>
                  <div className="text float-left">
                    <h6>Phone &amp; Fax</h6>
                    <span>(732) 803-01 03, (732) 806-01 04</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="x-construction">
          <Spin indicator={<Icon type="loading" />} /> <br/><br/> Please check back later
        </div> */}
        {/* <Content className="contact-page">
          <div className="banner">
            <div className="contact-note" data-aos="slide-right">
              <Title className="top-note">
                CONTACT US
              </Title>
              <p className="bottom-note">
                Have anyting to discuss with us? We are always ready to help!
              </p>
              <div className="contact-links">
                <img src="/img/skype.svg" alt=""/>
                <img src="/img/gmail.svg" alt=""/>
                <img src="/img/twitter-circular-button.svg" alt=""/>
              </div>
            </div>
          </div>
          <div className="main">
            <section className="contact-holder">
              <Row  gutter={16}>
                <Col span={12} xs={24} sm={12} lg={12} className="left">
                  <Title className="contact-heading">
                    GET IN TOUCH WITH US
                  </Title>
                  <p className="note">
                    We are very approachable and would love to speak to you. Feel free to call, or send us an email.
                  </p>
                  <div className="details-list">
                    <div className="details">
                      <Card className="icon-holder">
                        < img src="/img/maps-and-flags.svg" alt=""/>
                      </Card>
                      <p className="details-content">
                        56 Caleb Road, Califonia, SA 02118
                      </p>
                    </div>
                    <div className="details">
                      <Card className="icon-holder">
                        < img src="/img/message-closed-envelope.svg" alt=""/>
                      </Card>
                      <p className="details-content">
                        contact@orsity.com
                      </p>
                    </div>
                    <div className="details">
                      <Card className="icon-holder">
                        < img src="/img/telephone.svg" alt=""/>
                      </Card>
                      <p className="details-content">
                        Tel: +1 (555) 555-555
                      </p>
                    </div>
                  </div>
                </Col>
                <Col span={12}  xs={24} sm={12} lg={12} className="right">
                  <Card className="holder">
                    <Title  className="contact-heading">
                      <center>  SEND US A MESSAGE</center>
                    </Title>
                    <div className="xform">
                <div className="xcard">
                <Form 
                  className="signup-form"
                  onSubmit={(e) => {
                    this.handleSubmit(e);
                  }}
                >
                   <div className="xheader">
                  <h5>Send Us A Message</h5>
                  </div>
                  <Row gutter={8}>
                      <Col span={12}>
                      <FormItem >
                    {getFieldDecorator('firstName', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your first name'
                        }
                      ]
                    })(
                      <Input
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="user"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="firstName"
                        placeholder="First Name"
                      />
                    )}
                  </FormItem>
                      </Col>
                      <Col span={12}>
                      <FormItem>
                    {getFieldDecorator('lastName', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your last name'
                        }
                      ]
                    })(
                      <Input
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="user"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="lastName"
                        placeholder="Last Name"
                      />
                    )}
                  </FormItem>

                      </Col>
                </Row>

                  <FormItem>
                    {getFieldDecorator('email', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your email'
                        },
                        {
                          type: 'email',
                          message: 'The input is not valid email'
                        }
                      ]
                    })(
                      <Input
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="mail"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="email"
                        placeholder="Email"
                      />
                    )}
                  </FormItem>
                  <FormItem >
                    {getFieldDecorator('password', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your password'
                        },
                        {
                          min: 6,
                          message: 'Password should be at least 6 characters'
                        }
                      ]
                    })(
                      <TextArea
                        rows="6"
                        onChange={e => this.handleChange(e)}
                        prefix={
                          <Icon
                            type="lock"
                            style={{ color: 'rgba(0,0,0,.25)' }}
                          />
                        }
                        name="password"
                        placeholder="Your message"
                      />
                    )}
                  </FormItem>
                  
                  <FormItem>
                        <Button block type="primary" htmlType="submit" className="xpad-btn">
                        <Icon type="loading" style={{ fontSize: 15 }} spin /> 
                        </Button>
                  </FormItem>
                </Form>
                </div>
            </div>
                  </Card>
                </Col>
              </Row>
            </section>
          </div>
        </Content> */}
        <Footer />
      </div>
    )
  }
}

const WrappedSignupForm = Form.create()(Contact);
export default WrappedSignupForm;

